import React from 'react';
import Reveal from '../../../shared/Reveal/Reveal';
import './FeaturedCompanies.css';

const FeaturedCompanies = ({ title = 'Featured Companies', items }) => {
  if (!items?.length) return null;

  return (
    <section className="featured-companies">
      <div className="featured-companies__inner">
        <Reveal>
          <h2 className="featured-companies__title">{title}</h2>
        </Reveal>

        <Reveal className="featured-companies__panel" delay={80}>
          <div className="featured-companies__grid">
            {items.map(({ name, category, text, logo }) => (
              <article key={name} className="featured-companies__cell">
                {logo ? (
                  <img
                    className="featured-companies__logo"
                    src={logo}
                    alt=""
                    aria-hidden="true"
                  />
                ) : null}
                <div className="featured-companies__copy">
                  <h3 className="featured-companies__name">{name}</h3>
                  <p className="featured-companies__category">{category}</p>
                  <p className="featured-companies__text">{text}</p>
                </div>
              </article>
            ))}
          </div>
        </Reveal>
      </div>
    </section>
  );
};

export default FeaturedCompanies;
